// Copyright (c) 2017 Deere & Company

import {
    closeModal,
    openModal,
    updateCommentsToDealer,
    updateInternalDeereComments
} from './modal';
import {
    readSpaTypes,
    updateSpaType
} from './spa-types';
import {putSpaClaim} from './put-spa-claim';
import {readSpaClaim} from './get-spa-claim';
import {resetSpaClaim} from './reset-spa-claim';
import {updateCustomContribution} from './custom-contributions';
import {updateSelectedContribution} from './selectedContribution';
import {updateStatus} from './update-status';

export default {
    closeModal,
    openModal,
    putSpaClaim,
    readSpaClaim,
    readSpaTypes,
    resetSpaClaim,
    updateCommentsToDealer,
    updateCustomContribution,
    updateInternalDeereComments,
    updateSelectedContribution,
    updateSpaType,
    updateStatus
};



// WEBPACK FOOTER //
// ./src/tabm/spa-details/action-creators/index.js